"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToMiltaryTime = convertToMiltaryTime;
function convertToMiltaryTime(time) {
    var _a = time === null || time === void 0 ? void 0 : time.split(/[:\s]/), hh = _a[0], mm = _a[1], period = _a[2];
    var hour = parseInt(hh);
    var minute = mm;
    if (isNaN(hour) || isNaN(minute) || hour < 1 || hour > 12 || minute < 0 || minute > 59) {
        // Invalid input, return an error message or handle as needed.
        return "Invalid time input";
    }
    if (period === "PM" && hour !== 12) {
        hour += 12;
    }
    else if (period === "AM" && hour === 12) {
        // Handle "12:00 AM" as midnight (00:00)
        hour = 0;
    }
    // Format hour and minute as two-digit strings
    var formattedHour = hour.toString().padStart(2, "0");
    var formattedMinute = minute.padStart(2, "0");
    // Construct and return the military time string
    var militaryTime = "".concat(formattedHour, ":").concat(formattedMinute);
    return militaryTime;
}
